import { Action } from 'redux';
import { select, put } from 'redux-saga/effects';
import { AppState, ErrorAction } from 'store';
import { IfcPaymentStateModel, PaymentDetailsModel } from 'models/Payment';
import { PaymentActionTypes, PaymentActions } from '../';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface UpdateIfcPaymentAction extends Action<PaymentActionTypes.UPDATE_IFC_PAYMENT> {
    ifcPaymentState: IfcPaymentStateModel;
}

export interface UpdateIfcPaymentActionStart extends Action<PaymentActionTypes.UPDATE_IFC_PAYMENT_START> {
}

export interface UpdateIfcPaymentActionSuccess extends Action<PaymentActionTypes.UPDATE_IFC_PAYMENT_SUCCESS> {
    ifcPaymentState: IfcPaymentStateModel;
    paymentDetails: PaymentDetailsModel;
}

export interface UpdateIfcPaymentActionError extends ErrorAction<PaymentActionTypes.UPDATE_IFC_PAYMENT_ERROR> {
}

export const updateIfcPayment: (ifcPaymentState: IfcPaymentStateModel) => UpdateIfcPaymentAction = (ifcPaymentState: IfcPaymentStateModel) => ({
    type: PaymentActionTypes.UPDATE_IFC_PAYMENT,
    ifcPaymentState
});
updateIfcPayment[ACTION_CREATOR_NAME] = 'updateIfcPayment';

export type UpdateIfcPaymentFunc = (...args: Parameters<typeof updateIfcPayment>) => void;

export function* updateIfcPaymentSaga({ ifcPaymentState }: UpdateIfcPaymentAction): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.UPDATE_IFC_PAYMENT_START
    });

    try {
        let state: AppState = yield select();

        let paymentDetails = {
            ...state.paymentState.paymentDetails,
            ifcDeposit: ifcPaymentState.deposit,
            ifcDepositPercentage: ifcPaymentState.depositPercentage,
            ifcMonthlyAmount: ifcPaymentState.monthlyPayment,
            ifcNumMonths: ifcPaymentState.months,
            total: state.basketState.basket!.totalPriceWithTax.value
        };

        let sessionId = userHelper.getSessionId();
        let username = userHelper.getCurrentUserName();

        yield api.hybris.savePaymentDetails(username, sessionId!, paymentDetails);

        yield put<PaymentActions>({
            type: PaymentActionTypes.UPDATE_IFC_PAYMENT_SUCCESS,
            ifcPaymentState,
            paymentDetails
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.UPDATE_IFC_PAYMENT_ERROR,
            error: errorToBasketErrorModel(error, 'updateIfcPaymentSaga')
        });

        return false;
    }
}